<div class="container-capped-sm relative">
  <ngx-spinner name="verify-phone" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
	<form #phoneAndNationalCodeForm="ngForm">
		<section class="kp-card m-2">
			<p class="fw-bold fs-10">تایید شماره تلفن همراه</p>
			<div class="form-group">
				<label for="phone-number">شماره تلفن همراه</label>
				<input name="phone-number"
				 	[(ngModel)]="model.mobile"
				  [required]="true" type="text" class="form-control" id="name"
					(ngModelChange)="verificationState = 'NotStarted';"
					placeholder="شماره تلفن همراه">
			</div>
			<div class="form-group">
				<label for="national-code">کد ملی</label>
				<input name="national-code"
					[(ngModel)] = "model.nationalCode"
					(ngModelChange)="verificationState = 'NotStarted';"
					[required]="true" type="text" class="form-control" id="national-code"
					placeholder="کد ملی">
			</div>
			<div class="text-center mt-3">
				<button class="btn btn-primary"
					[disabled]="!phoneAndNationalCodeForm.valid" type="button"
					(click)="checkPhoneAndNationalCode()">
					بررسی تطبیق کد ملی و شماره تلفن همراه</button>
			</div>
			<div [ngSwitch]="verificationState"  class="text-center">
				<ng-container *ngSwitchCase="'Success'">
					<div class="alert alert-success mt-3" role="alert">
						کد ملی و شماره تلفن همراه با هم تطبیق دارند.
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'Failed'">
					<div class="alert alert-danger mt-3" role="alert">
						کد ملی و شماره تلفن همراه با هم تطبیق ندارند.
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'Error'">
					<div class="alert alert-danger mt-3" role="alert">
						مشکلی در برقراری ارتباط با سرور پیش آمده است.
					</div>
				</ng-container>
			</div>
		</section>
	</form>
</div>
